
import { useState } from "react";
const { REACT_APP_ENV } = process.env;

function loadScript(src) {
  return new Promise((resolve) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}

export function useEasebuzzPayment() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paymentResponse, setPaymentResponse] = useState(null);
  const isTestEnv = REACT_APP_ENV === "dev" || REACT_APP_ENV === "uat";


  const initiateEasebuzzPayment = async ({
    orderAccessKey,
    easebuzzKey,
    originalAmount,
    onModalClose,
  }) => {
    try {
      setLoading(true);
      setError(null);

      if (!easebuzzKey) throw new Error("Merchant key missing");
      if (!orderAccessKey) throw new Error("Missing order access_key");

      const scriptLoaded = await loadScript(
        "https://ebz-static.s3.ap-south-1.amazonaws.com/easecheckout/v2.0.0/easebuzz-checkout-v2.min.js"
      );
      if (!scriptLoaded)
        throw new Error("Easebuzz checkout script failed to load");
      if (!globalThis.EasebuzzCheckout)
        throw new Error("EasebuzzCheckout not found");

      const easebuzzCheckout = new globalThis.EasebuzzCheckout(
        easebuzzKey,
        isTestEnv ? "test" : "prod"
      );

      const options = {
        layout: "popup",
        access_key: orderAccessKey,
        onResponse: (response) => {
          setPaymentResponse(response);
          setLoading(false);
        },
        modal_close_handler: () => {
          setLoading(false);
          if (typeof onModalClose === "function") {
            onModalClose(originalAmount);
          }
        },
        theme: "#1A407D",
      };

      // ✅ Don't await or unwrap — just call it
      easebuzzCheckout.initiatePayment(options);


      // Target the iframe container
      setTimeout(() => {
        const container = document.querySelector('[id*="easebuzz-container-v2"]');
        const iframe = document.querySelector('[id*="easebuzz-checkout-frame-v2"]');
        const backdrop = document.querySelector('[id*="easebuzz-checkout-backdrop-v2"]');

        if (container) {
          if (backdrop) {
            backdrop.style.setProperty('background', 'rgba(0, 0, 0, 0.7)', 'important');
          }

          // Scale and center the iframe
          if (iframe) {
            iframe.style.setProperty('transform', 'scale(0.85)', 'important');
            iframe.style.setProperty('transform-origin', 'center', 'important');
            iframe.style.setProperty('max-height', '85vh', 'important');
            iframe.style.setProperty('height', '85vh', 'important');
            iframe.style.setProperty('top', '50%', 'important');
            iframe.style.setProperty('left', '50%', 'important');
            iframe.style.setProperty('translate', '-50% -50%', 'important');
            iframe.style.setProperty('position', 'absolute', 'important');
          }
        }
      }, 1000);
    } catch (err) {
      console.error("Easebuzz Payment Error:", err);
      setError(err.message || String(err));
      setLoading(false);
    }
  };

  return { initiateEasebuzzPayment, loading, error, paymentResponse };
}